import { Flex, Text } from '@optiaxiom/react';
import { IconCodeBranch, IconSparkles } from '@optimizely/axiom-icons';

import { DirectoryAgent } from '../../../services/agent-directory';

import { styles } from './AgentCardView.css';

type AgentCardViewProps = {
  agent: DirectoryAgent;
  isSelected?: boolean;
  onSelect?: () => void;
};

const AgentTypeIcon = {
  specialized: <IconSparkles size="16" />,
  workflow: <IconCodeBranch size="16" />,
};

export function AgentCardView({ agent, isSelected = false, onSelect }: AgentCardViewProps) {
  const agentIcon = AgentTypeIcon[agent.agent_type] || <IconSparkles size="16" />;

  return (
    <Flex
      className={`${styles.cardViewContainer} ${isSelected ? styles.selected : ''}`}
      onClick={onSelect}
      style={{ cursor: onSelect ? 'pointer' : 'default' }}
    >
      {/* Tags */}
      <Flex flexDirection="row" gap="8" flexWrap="wrap">
        {agent.tags && agent.tags.length > 0 ? (
          agent.tags.slice(0, 2).map((tag, index) => (
            <Text key={tag.name || `tag-${index}`} fontSize="xs" color="fg.tertiary">
              {tag.name}
            </Text>
          ))
        ) : (
          <Text fontSize="xs" color="fg.tertiary">
            {/* Empty space to maintain layout */}
          </Text>
        )}
      </Flex>

      {/* Name and Icon */}
      <Flex flexDirection="row" justifyContent="space-between" gap="8">
        <Text fontSize="md">{agent.name}</Text>
        <Flex className={styles.icon}>{agentIcon}</Flex>
      </Flex>

      {/* Description */}
      <Text fontSize="sm" color="fg.tertiary" lineClamp="2">
        {agent.description || 'No description available'}
      </Text>
    </Flex>
  );
}
